import { Avatar, Box, Grid, IconButton, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Container } from '@mui/system';
import React from 'react'


const useStyles = makeStyles ((theme) => ({
  footer: {
    // height: "50vh",
    backgroundColor: "#374d7c",
    // opacity: '0.45',
    padding: '50px 0 50px 0',
    // border: '1px solid #fff'
  },
}));

const Footer = () => {
    const classes = useStyles();
  return (
    <div className={classes.footer} >
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Box sx={{display: "flex", flexDirection: 'column',  justifyContent: {xs: 'center', sm: 'start', md: 'start' } }}>
              <Box sx={{display: "flex", flexDirection: 'row',  justifyContent: {xs: 'center', sm: 'start', md: 'start' }, alignItems: "center"}}>
                <IconButton sx={{textAlign: {xs: 'center' }}}>
                  <Avatar src='/images/aniekanprofile-bg.png' alt='profile' />
                </IconButton>
                <Typography
                  variant='h5'
                  style={{
                    lineHeight: "24px", fontSize: '20px', letterSpacing: '0.25px', fontWeight: '700', color: '#fff', cursor: 'pointer', textDecoration: 'none', marginLeft: '20px'
                  }}
                  component='a'
                  href='/'
                >
                  Aniekan Edet
                </Typography>
              </Box>
              <Box sx={{textAlign: {xs: 'center', sm: 'start'}}}>
                <Typography
                  variant='subtitle2'
                  style={{
                    marginTop: "10px", fontSize: '14px', letterSpacing: '0.75px', fontWeight: '500', color: '#fff', cursor: 'pointer', textDecoration: 'none',  
                  }}
                >
                  Frontend Developer | Tech Support
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
              <div className={`${'social-icon'}`}>
                <a href='https://www.linkedin.com/in/aniekan-edet-03521a96/' target='_blank' rel='noreferrer'>
                  <img src='/images/nav-icon1.svg' alt='facebook-link' />
                </a>
                <a href='https://web.facebook.com/AniekangEdet' target='_blank' rel='noreferrer'>
                  <img src='/images/nav-icon2.svg' alt='linkedIn-link' />
                </a>
                <a href='http://www.twitter.com/agedet9060' target='_blank' rel='noreferrer'>
                  <img src='/images/nav-icon4.svg' alt='twitter-link' />
                </a>
                <a href='http://www.github.com/agedet' target='_blank' rel='noreferrer'>
                  <img src='/images/nav-icon6.svg' alt='twitter-link' />
                </a>
              </div>
              <Typography variant='subtitle2' style={{fontWeight: '400', fontSize: '14px', color: '#b8b8b8', letterSpacing: '0.5px', marginTop: '20px'}}>
                CopyRight 2022. All Rights Reserved.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default Footer